import { createTheme as createMuiTheme } from '@mui/material/styles';

export const DEFAULT_FONT_FAMILY = '"Helvetica Neue", Helvetica, Arial, sans-serif';

const palette = {
  primary: {
    main: '#BE53D2',
    dark: '#BE53D2',
  },
  action: {
    disabled: '#7A8793',
    disabledBackground: '#E6EAEE',
  },
  error: {
    main: '#ff4a55',
  },
  success: {
    main: '#19ab27',
  },
};

const components = {
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        fontWeight: 400,
        variants: [
          {
            props: { variant: 'contained', color: 'primary' },
            style: {
              '&.MuiButton-contained': {
                color: '#fff',
              },
              '&.Mui-disabled': {
                color: '#7A8793',
                backgroundColor: '#E6EAEE',
                boxShadow: 'none',
              },
            },
          },
        ],
      },
    },
  },
  MuiButtonGroup: {
    styleOverrides: {
      root: {
        '& .MuiButtonGroup-grouped': {
          boxShadow: 'none',
          '&:hover, &:focus, &:active': {
            boxShadow: 'none',
          },
        },
      },
    },
  },
  MuiToggleButton: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        variants: [
          {
            props: { color: 'primary' },
            style: {
              color: '#333',
              fontWeight: 400,
              padding: '6px 12px',
              minWidth: 75,
              '&.Mui-selected': {
                backgroundColor: '#BE53D2',
                color: '#FFF',
                '&:hover': {
                  backgroundColor: '#BE53D2',
                },
              },
            },
          },
        ],
      },
    },
  },
  MuiTypography: {
    styleOverrides: {
      root: {
        color: 'rgba(0, 0, 0, 0.87)',
      },
    },
  },
  MuiFormLabel: {
    styleOverrides: {
      asterisk: ({ theme }) => ({
        color: theme.palette.error.main,
      }),
    },
  },
  MuiSelect: {
    defaultProps: {
      MenuProps: {
        PaperProps: {
          sx: {
            '& .MuiMenuItem-root': {
              fontSize: 14,
            },
          },
        },
      },
    },
    styleOverrides: {
      select: {
        '&.MuiInputBase-inputSizeSmall': {
          fontSize: 14,
        },
      },
    },
  },
};

export const createTheme = () => {
  const theme = createMuiTheme({
    components,
    palette,
    typography: {
      fontFamily: DEFAULT_FONT_FAMILY,
    },
  });

  return theme;
};
